import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { changeIsCloseable, changeModalContent, changeModalState } from "../../../redux/actions/modal/modal";
import { RootState } from "../../../redux/reducers/root";
import Toc from "../../Toc/Toc";

import "./AmpFooter.css";

// TODO Hook in logic for font size change
// TODO Terms and Conditions Modal
export default function AmpFooter(): JSX.Element{

    const { t } = useTranslation('footer');

    const modalState = useSelector((state: RootState) => state.modalReducer);

    const modalContentAriaLabel: string = modalState['contentAriaLabel'];
    
    const dispatch = useDispatch();

    const storageFontSize = window.localStorage.getItem("ampFontSize");
    const [fontSize, setFontSize] = useState<"s" | "m" | "l">(
        storageFontSize && ["s", "m", "l"].includes(storageFontSize) ? 
            (storageFontSize as "s" | "m" | "l") : "s");

    useEffect(() => {
        changeTextSize(fontSize);
    }, [fontSize])

    const openTocModal = () => {
        const ariaLabelText = t("toc-title") as string;
        if (modalContentAriaLabel !== ariaLabelText) {
            dispatch(changeIsCloseable(true));
            dispatch(changeModalContent(<Toc showTitle={true} showPrintButton={true} />,
                undefined,
                ariaLabelText));
        }
        dispatch(changeModalState("modal-fade-in"));
    }

    const changeTextSize = (size: "s" | "m" | "l") => {
        setFontSize(size);
        switch (size) {
            case "l":
                document.documentElement.classList.remove("medium-text");
                document.documentElement.classList.add("large-text");
                break;
            case "m":
                document.documentElement.classList.remove("large-text");
                document.documentElement.classList.add("medium-text");
                break;
            default:
                document.documentElement.className = "";
        }
        size === "s" ? window.localStorage.removeItem("ampFontSize") : window.localStorage.setItem("ampFontSize", size);
    }

    return(
        <>
        <div className="span-page-blue-bar amp-footer"></div>
        <div className="amp-footer" >
            <div className="footer-list">
                    <div className="font-size-change">
                        <button onClick={() => changeTextSize("s")}><img src={"./images/zoom_0_"+ (fontSize === "s" ? "curr" : "off") +".png"} alt="Small Font Size"></img></button>
                        <button onClick={() => changeTextSize("m")}><img src={"./images/zoom_1_"+ (fontSize === "m" ? "curr" : "off") +".png"} alt="Medium Font Size"></img></button>
                        <button onClick={() => changeTextSize("l")}><img src={"./images/zoom_2_"+ (fontSize === "l" ? "curr" : "off") +".png"} alt="Large Font Size"></img></button>
                    </div>
                    
                    <div className="footer-privacy-policy">
                        <a className="amp-anchor" href={t("policy-link")} target = "_blank" rel ="noreferrer noopener" >
                            {t("privacy-policy") as string}
                        </a>
                    </div>
                    
                
                    <div className="footer-toc" onClick={() => {openTocModal()}}>
                        <p>{t("terms-and-conditions") as string}</p>
                    </div>
                
                    <div className="all-rights-reserved">
                        <p>{t("all-rights-reserved") as string}</p>
                    </div>
                
            </div>
        </div>
        </>
    );
}